import {environment} from "environments";

(() => {
  class EditAnswerController {
    constructor($scope, Utils) {
      'ngInject';

      Object.assign(this, {
        $scope,
        Utils,
        LMNUK_1695: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV),
        BOD_1144:['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV),
      });

      if (!$scope.ngDialogData.answer) {
        $scope.ngDialogData.answer = { warning_level: 0 };
      }
    }

    replaceDotForDash(warning_level) {
      return this.Utils.replaceDotForDash(warning_level);
    }

  }

  EditAnswerController.$inject = ["$scope", "Utils"];
  angular.module('pims').controller('EditAnswerController', EditAnswerController);
})();
